import React from "react";

interface Props {
  size?: number;
  color?: string;
}

const LinkedInIcon = ({ size = "16", color = "currentColor" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LinkedIn icon</title>
      <path
        d="M3.63293 16.8125V6.01732H0.20263V16.8125H3.63293ZM1.91823 4.54254C3.11443 4.54254 3.85901 3.7136 3.85901 2.6777C3.83673 1.61843 3.11448 0.8125 1.94092 0.8125C0.767556 0.8125 0.000244141 1.61845 0.000244141 2.6777C0.000244141 3.71365 0.744642 4.54254 1.89583 4.54254H1.91812H1.91823ZM5.53159 16.8125H8.9619V10.7839C8.9619 10.4613 8.98418 10.139 9.07477 9.90836C9.32275 9.26374 9.88717 8.59609 10.8348 8.59609C12.0761 8.59609 12.5726 9.58604 12.5726 11.0372V16.8124H16.0027V10.6226C16.0027 7.30671 14.3104 5.76389 12.0535 5.76389C10.203 5.76389 9.39045 6.84584 8.93907 7.58275H8.96197V6.0171H5.53167C5.57669 7.03006 5.53167 16.8123 5.53167 16.8123L5.53159 16.8125Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedInIcon;
